module.exports = __webpack_public_path__ + "static/media/error.7f7dacdd.svg";